import { required, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      setting_branches: {
        required: helpers.withMessage(i18n.global.t('Please select branch.'), required)
      }
    }
  }
};
